const auxiliary = (props) => {
    return (
        props.children
    );
};

export default auxiliary;